import { forwardRef, type SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import { cx } from '@/lib/cx';

export interface SelectOption<V extends string | number = string> {
  value: V;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  options: ReadonlyArray<SelectOption<string | number>>;
  /** 未選択時の表示（value=""）。指定すると先頭に追加 */
  placeholder?: string;
  invalid?: boolean;
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'full';
}

/** ネイティブ select（キーボード操作・入力効率を優先） */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, placeholder, invalid, width = 'full', className, ...rest },
  ref,
) {
  return (
    <span className={cx('bs-select', `bs-w-${width}`, className)}>
      <select ref={ref} aria-invalid={invalid || undefined} className="bs-input bs-select__control" {...rest}>
        {placeholder != null && <option value="">{placeholder}</option>}
        {options.map((o) => (
          <option key={String(o.value)} value={o.value} disabled={o.disabled}>
            {o.label}
          </option>
        ))}
      </select>
      <ChevronDown className="bs-select__chevron" size={16} aria-hidden />
    </span>
  );
});
